import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {UserBankingDataComponent} from '../user-banking-data/user-banking-data.component';
import * as moment from 'moment/moment';
import {TerminalDeliveryComponent} from '../terminal-delivery/terminal-delivery.component';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {ApiAmenaService} from '../../services/api-amena.service';
import {NormalizadorService} from '../../services/normalizador.service';
import {GeneralService} from '../../services/general.service';
import {environment} from 'src/environments/environment';
import {MustMatch} from 'src/app/utils/validators/email-confirm-validator';
import {autocompleteValidator} from 'src/app/utils/validators/autocomplete-validator';
import {cifValidator, dniValidator, getMaxLengthByDoc, nieValidator} from 'src/app/utils/validators/spanish-id-validator';
import {UserBankingDataListener} from '../../interface/user-banking-data-listener';
import {TerminalDeliveryListener} from '../../interface/terminal-delivery-listener';
import {UserDataModel} from '../../interface/user-data-model';
import {UserDataListener} from '../../interface/user-data-listener';
import {ApiResponse} from '../../interface/ApiResponse';
import {TerminalDeliveryModel} from '../../interface/terminal-delivery-model';
import {UserBankingDataModel} from '../../interface/user-banking-data-model';
import {getNameStreet, onChangeZip, searchRoadType} from 'src/app/utils/normalizerFunctions';
import { brands, maxDate, minDate } from 'src/app/shared/constantes';
import { ShoppingCartService } from '../../services/shopping-cart-service';
import { MatStepper } from '@angular/material/stepper';
import { ShopingCartComponent } from '../shoping-cart/shoping-cart.component';

@Component({
    selector: 'app-user-data-form',
    templateUrl: './user-data-form.component.html',
    styleUrls: ['./user-data-form.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class UserDataFormComponent implements OnInit, UserBankingDataListener, TerminalDeliveryListener, AfterViewInit, OnDestroy {
    @Input() showBankingData = false;
    @Input() showTitleAndCard = true;
    @Input() requestCompanyInfo = false;
    @Input() model = new UserDataModel();
    @Input() listener: UserDataListener;
    @ViewChild('terminalDelivery') terminalDelivery: TerminalDeliveryComponent;
    @ViewChild('userBankingData') userBankingData: UserBankingDataComponent;

    public country = environment.googleMapsCountry;
    public formGroup: FormGroup;
    public requireCif = false;
    public waitingForBankingData = false;
    public countries: any[] = [];
    public selectedCountry: string;
    public selectedSex: string;
    public datosTipoVia = [];
    public datosProvincia = [];
    public datosCobertura: any;
    public env = environment;
    public pdv: any;
    public maxDate: Date = maxDate;
    public minDate: Date = minDate;
    public showDelivery: boolean = false;
    public staircaseTypes: any[] = [];
    public floorTypes: any[] = [];
    public staircaseFilteredOptions: Observable<any[]>;
    public floorFilteredOptions: Observable<any[]>;
    public maxLengthByDoc = 9;
    public documentTypes;
    public dataCustomer: any;

    constructor(
        private amenaApi: ApiAmenaService,
        private formBuilder: FormBuilder,
        private normalizadorService: NormalizadorService,
        private generalService: GeneralService,
        private stepper: MatStepper,
        private shoppingCartService: ShoppingCartService
    ) { }

    getModel() {
        return this.model;
    }

    ngOnInit(): void {
        console.log('INICIAMOS COMPONENTE USER DATA FORM');
        this.formGroup = this.formBuilder.group({
            doctype: [this.model.doctype, Validators.required],
            doc: [this.model.doc, Validators.required],
            country: [this.model.country, Validators.required],
            firstName: [this.model.firstName, Validators.required],
            surname1: [this.model.surname1, Validators.required],
            surname2: [this.model.surname2, /*Validators.required*/],
            birthday: [this.model.birthday, Validators.required],
            sex: [this.model.sex, Validators.required],
            company: [this.model.company],
            tipoVia: [this.model.tipoVia],
            nombreVia: [this.model.nombreVia, Validators.required],
            numero: [this.model.numero, Validators.required],
            planta: [this.model.planta],
            puerta: [this.model.puerta],
            escalera: [this.model.escalera],
            codigoPostal: [this.model.codigoPostal, Validators.required],
            localidad: [this.model.localidad, Validators.required],
            provincia: [this.model.provincia, Validators.required],
            phone: [this.model.phone, [
                Validators.required,
                Validators.pattern('[0-9 ]*'),
                Validators.minLength(9),
                Validators.maxLength(9)
            ]],
            email: [this.model.email, [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
            email_confirm: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
            terminal_delivery: [this.model.terminalDelivery],
        }, {
            validator: MustMatch('email', 'email_confirm')
        });

        this.fillCountries();

        this.amenaApi.getDatosTipoVia()
            .subscribe((data: any) => {
                if (data != null) {
                    this.datosTipoVia = data;
                }
            });

        this.amenaApi.getProvincias()
            .subscribe((data: any) => {
                if (data != null) {
                    this.datosProvincia = data;
                }
            });

        this.normalizadorService.getResultadoCobertura()
            .subscribe(async (value) => {
                this.datosCobertura = value;
                await this.fillDirIfData();
            });

        this.amenaApi.getPDV()
            .subscribe(data => {
                if (data != null) {
                    this.pdv = data;
                }
            });

        this.amenaApi.getStaircaseTypes()
            .subscribe((data: any[]) => {
                if (data != null) {
                    this.staircaseTypes = data;
                    this.staircaseFilteredOptions = this.formGroup.get('escalera').valueChanges.pipe(
                        startWith(''),
                        map(value => this._filter(value, this.staircaseTypes))
                    );
                    this.formGroup.get('escalera').setValidators(autocompleteValidator(this.staircaseTypes.map(i => i.code)));
                    this.formGroup.get('escalera').updateValueAndValidity();
                }
            });

        this.amenaApi.getFloorTypes()
            .subscribe((data: any[]) => {
                if (data != null) {
                    this.floorTypes = data;
                    this.floorFilteredOptions = this.formGroup.get('planta').valueChanges.pipe(
                        startWith(''),
                        map(value => this._filter(value, this.floorTypes))
                    );
                    this.formGroup.get('planta').setValidators(autocompleteValidator(this.floorTypes.map(i => i.code)));
                    this.formGroup.get('planta').updateValueAndValidity();
                }
            });

        this.amenaApi.getDataFromNotCustomer()
            .subscribe((data: any) => {
                if (data) {
                    this.setDataFromNotCustomer(data);
                }
            });

        this.amenaApi.getDocumentTypes()
            .subscribe((data: any) => {
                if (data) {
                    this.documentTypes = data;
                }
            });

        this.amenaApi.getDataFromCustomer()
            .subscribe((data: any) => {
                if (data) {
                    this.dataCustomer = data;
                    this.setDataFromCustomer(this.dataCustomer);
                }
            });

        this.stepper.selectionChange.subscribe(data => {
            if (data.selectedIndex === this.stepper._steps.length - 2) {
                const itemsForms = this.shoppingCartService.getShoppingCart().getOperation().getItemForms();
                if (itemsForms && itemsForms.length) {
                    this.showDelivery = false;
                    itemsForms.map(formMobile => {
                        let dataMobile = formMobile.getRawValue();
                        if (dataMobile && (dataMobile.type_operation.includes('logistica') || (dataMobile.terminal && dataMobile.terminal !== ''))) {
                            this.showDelivery = true;
                        }
                    })
                    if (this.showDelivery) {
                        this.formGroup.get('terminal_delivery').setValidators(Validators.required);
                    } else {
                        this.formGroup.get('terminal_delivery').clearValidators();
                        this.formGroup.get('terminal_delivery').updateValueAndValidity();
                    }
                }
            }
        });

        this.formGroup.get('provincia').disable();
    }

    ngAfterViewInit(): void {
        this.formGroup.statusChanges
            .subscribe(data => {
                if (this.formGroup.get('doctype').value !== null) {
                    this.generalService.setFormularioUserData(this.formGroup);
                }
            });

        this.userBankingData.formGroup.statusChanges
            .subscribe(data => {
                this.generalService.setFormularioUserBank(this.userBankingData.formGroup);
            });
            
        // Metodo que se llama cuando pulsamos si en el modal de guardar borrador
        // Limpiamos todos los controls del form y guardamos los datos del user
        this.generalService.getSaveDataUserInvalid()
            .subscribe(data => {
                if (data === true) {
                    for (const key in this.formGroup.controls) {
                        this.formGroup.get(key).clearValidators();
                        this.formGroup.get(key).updateValueAndValidity();
                    }
                    this.generalService.setFormularioUserData(this.formGroup);

                    console.log('ORIGINAL', this.formGroup);
                }
            });
    }

    fillData(userData: UserDataModel) {
        this.model = userData;
        this.formGroup.get('doctype').patchValue(this.model.doctype);
        this.changeTypeDocument(this.model.doctype);
        this.setMaxLengthByDoc(this.model.doctype);
        this.formGroup.get('doc').patchValue(this.model.doc);
        this.formGroup.get('country').patchValue(this.model.country);
        this.formGroup.get('firstName').patchValue(this.model.firstName);
        this.formGroup.get('surname1').patchValue(this.model.surname1);
        this.formGroup.get('surname2').patchValue(this.model.surname2);
        this.formGroup.get('birthday').patchValue(this.model.birthday);
        this.formGroup.get('sex').patchValue(this.model.sex);
        this.formGroup.get('company').patchValue(this.model.company);
        this.formGroup.get('tipoVia').patchValue(this.model.tipoVia);
        this.formGroup.get('nombreVia').patchValue(this.model.nombreVia);
        this.formGroup.get('numero').patchValue(this.model.numero);
        this.formGroup.get('planta').patchValue(this.model.planta);
        this.formGroup.get('puerta').patchValue(this.model.puerta);
        this.formGroup.get('escalera').patchValue(this.model.escalera);
        this.formGroup.get('codigoPostal').patchValue(this.model.codigoPostal);
        this.formGroup.get('localidad').patchValue(this.model.localidad);
        this.formGroup.get('provincia').patchValue(this.model.provincia);
        this.formGroup.get('phone').patchValue(this.model.phone);
        this.formGroup.get('email').patchValue(this.model.email);
        this.formGroup.get('email_confirm').patchValue(this.model.email);

        if (this.model.codigoPostal && this.model.codigoPostal !== '') {
            this.onChangeZip(this.model.codigoPostal);
        }

        if (this.model.sex.toLowerCase() === 'male') {
            this.selectedSex = 'M';
            this.formGroup.get('sex').patchValue('M');
        } else if (this.model.sex.toLowerCase() === 'female') {
            this.selectedSex = 'F';
            this.formGroup.get('sex').patchValue('F');
        }

        this.userBankingData.setData(this.model.bankingData);
        this.generalService.setFormularioUserData(this.formGroup);
    }

    // Rellena los campos de dirección si existen datos
    fillDirIfData() {
        if (this.datosCobertura) {
            console.log('[DATOS DE COBERTURA]', this.datosCobertura);

            if (this.datosCobertura.value.codigoPostalCobertura) {
                this.formGroup.get('codigoPostal').patchValue(this.datosCobertura.value.codigoPostalCobertura);
                this.onChangeZip(this.datosCobertura.value.codigoPostalCobertura);
            } else if (this.datosCobertura.value.localidadCobertura) {
                this.formGroup.get('provincia').patchValue(this.datosCobertura.value.provinciaCobertura);
            }
            if (this.datosCobertura.value.localidadCobertura) {
                this.formGroup.get('localidad').patchValue(this.datosCobertura.value.localidadCobertura);
            }
            if (this.datosCobertura.value.nombreViaCobertura) {
                this.formGroup.get('nombreVia').patchValue(this.datosCobertura.value.tipoViaCobertura ? this.datosCobertura.value.tipoViaCobertura + ' ' + this.datosCobertura.value.nombreViaCobertura : this.datosCobertura.value.nombreViaCobertura);
            }
            if (this.datosCobertura.value.numeroCobertura) {
                this.formGroup.get('numero').patchValue(this.datosCobertura.value.numeroCobertura);
            }
            if (this.datosCobertura.value.tipoViaCobertura) {
                this.formGroup.get('tipoVia').patchValue(this.datosCobertura.value.tipoViaCobertura);
            }
            if (this.datosCobertura.value.plantaCobertura) {
                this.formGroup.get('planta').patchValue(this.datosCobertura.value.plantaCobertura === 'No tiene' ? null : this.datosCobertura.value.plantaCobertura);
            }
            if (this.datosCobertura.value.puertaCobertura) {
                this.formGroup.get('puerta').patchValue(this.datosCobertura.value.puertaCobertura === 'No tiene' ? null : this.datosCobertura.value.puertaCobertura);
            }
            if (this.datosCobertura.value.resultadoConsultaCobertura && this.datosCobertura.value.resultadoConsultaCobertura.cimaStairCode) {
                this.formGroup.get('escalera').patchValue(this.datosCobertura.value.resultadoConsultaCobertura.cimaStairCode);
            }
        }
    }

    fillCountries() {
        this.amenaApi.getCountries()
            .subscribe((data: ApiResponse) => {
                this.countries = data.msg;
                this.selectedCountry = 'Spain';
            }, (error) => {
                console.log(error);
            });
    }

    changeTypeDocument(value): void {
        const docValidators: ValidatorFn[] = [Validators.required];

        this.requireCif = value === 'CIF';

        if (this.requireCif) {
            this.formGroup.get('company').setValidators(Validators.required);
        } else {
            this.formGroup.get('company').clearValidators();
        }

        switch (value) {
            case 'DNI':
                docValidators.push(dniValidator());
                break;
            case 'NIF':
                docValidators.push(dniValidator());
                break;
            case 'NIE':
                if (this.formGroup.get('country').value === 'Spain') {
                    this.selectedCountry = '';
                    this.formGroup.get('country').patchValue('');
                }
                docValidators.push(nieValidator());
                break;
            case 'CIF':
                docValidators.push(cifValidator());
                break;
            default:
        }

        this.formGroup.get('doc').setValidators(docValidators);
        this.formGroup.get('doc').updateValueAndValidity();
        this.formGroup.get('company').updateValueAndValidity();
    }

    validateForm() {
        console.log('Entro en validación', this.formGroup);
        let checkTerminalDelivery = true;
        this.formGroup.markAllAsTouched();
        this.formGroup.updateValueAndValidity();

        if (!this.formGroup.get('tipoVia').value || this.formGroup.get('tipoVia').value === '') {
            searchRoadType(this.formGroup.get('nombreVia').value, this.datosTipoVia, 'code', this.formGroup.get('tipoVia'));
        }

        if (this.showTitleAndCard && this.showDelivery) {
            checkTerminalDelivery = this.formGroup.get('terminal_delivery').value && Object.keys(this.formGroup.get('terminal_delivery').value).length > 0;
            this.terminalDelivery.errorForm = !checkTerminalDelivery;
        } else {
            this.formGroup.get('terminal_delivery').patchValue(undefined);
        }

        if (this.formGroup.valid && checkTerminalDelivery) {
            this.model.doctype = this.formGroup.get('doctype').value;
            this.model.doc = this.formGroup.get('doc').value;
            this.model.country = this.formGroup.get('country').value;
            this.model.firstName = this.formGroup.get('firstName').value;
            this.model.surname1 = this.formGroup.get('surname1').value;
            this.model.surname2 = this.formGroup.get('surname2').value;
            this.model.birthday = this.formGroup.get('birthday').value;
            this.model.sex = this.formGroup.get('sex').value;
            this.model.company = this.formGroup.get('company').value;
            this.model.tipoVia = this.formGroup.get('tipoVia').value;
            this.model.nombreVia = this.formGroup.get('nombreVia').value;
            this.model.numero = this.formGroup.get('numero').value;
            this.model.planta = this.formGroup.get('planta').value;
            this.model.puerta = this.formGroup.get('puerta').value;
            this.model.escalera = this.formGroup.get('escalera').value;
            this.model.codigoPostal = this.formGroup.get('codigoPostal').value;
            this.model.localidad = this.formGroup.get('localidad').value;
            this.model.provincia = this.formGroup.get('provincia').value;
            this.model.phone = this.formGroup.get('phone').value;
            this.model.email = this.formGroup.get('email').value;
            this.model.terminalDelivery = this.formGroup.get('terminal_delivery').value;

            if (this.showBankingData) {
                if (this.userBankingData.checkFormGroup()) {
                    if (this.waitingForBankingData) {
                        this.waitingForBankingData = false;
                    } else {
                        this.listener.onSuccessfulValidation(this.model);
                    }
                } else {
                    const temporalBankingData = new UserBankingDataModel();

                    temporalBankingData.account_doctype = this.formGroup.get('doctype').value;
                    temporalBankingData.account_doc = this.formGroup.get('doc').value;
                    // temporalBankingData.account_country = this.formGroup.get('country').value;
                    temporalBankingData.account_firstName = this.formGroup.get('firstName').value;
                    temporalBankingData.account_surname1 = this.formGroup.get('surname1').value;
                    temporalBankingData.account_surname2 = this.formGroup.get('surname2').value;

                    this.waitingForBankingData = true;
                    this.userBankingData.setData(temporalBankingData);
                }
            } else {
                this.listener.onSuccessfulValidation(this.model);
            }
        } else {
            const elements: any = document.getElementsByClassName('mat-input-element ng-invalid');

            if (elements.length > 0) {
                elements[0].focus();
            }
        }
    }

    onAutocompleteSelected($event) {
        const addressComponents: any[] = $event.address_components;

        if (addressComponents != null && addressComponents.length > 0) {
            this.formGroup.get('tipoVia').patchValue('');
            this.formGroup.get('nombreVia').patchValue('');
            this.formGroup.get('numero').patchValue('');
            this.formGroup.get('planta').patchValue('');
            this.formGroup.get('puerta').patchValue('');
            this.formGroup.get('escalera').patchValue('');
            this.formGroup.get('codigoPostal').patchValue('');
            this.formGroup.get('localidad').patchValue('');
            this.formGroup.get('provincia').patchValue('');

            for (const addressComponent of addressComponents) {
                let field = '';
                const types: string[] = addressComponent.types;
                let value: string = addressComponent.long_name;

                if (types.includes('route')) {
                    field = 'nombreVia';
                    value = searchRoadType(value, this.datosTipoVia, 'code', this.formGroup.get('tipoVia'));
                } else if (types.includes('street_number')) {
                    field = 'numero';
                } else if (types.includes('postal_code')) {
                    field = 'codigoPostal';
                    this.onChangeZip(value);
                } else if (types.includes('locality')) {
                    field = 'localidad';
                } else if (types.includes('administrative_area_level_2')) {
                    field = 'provincia';
                    value = value.toUpperCase();
                }

                if (field !== '') {
                    this.formGroup.get(field).patchValue(value);
                }
            }
        }
    }

    // UserBankingDataListener
    onSuccessfulValidation(userBankingModel: UserBankingDataModel) {
        this.model.bankingData = userBankingModel;

        if (this.waitingForBankingData) {
            this.validateForm();
        }
    }

    getUserData() {
        const temporalBankingData = new UserBankingDataModel();

        temporalBankingData.account_doctype = this.formGroup.get('doctype').value;
        temporalBankingData.account_doc = this.formGroup.get('doc').value;
        // temporalBankingData.account_country = this.formGroup.get('country').value;
        temporalBankingData.account_firstName = this.formGroup.get('firstName').value;
        temporalBankingData.account_surname1 = this.formGroup.get('surname1').value;
        temporalBankingData.account_surname2 = this.formGroup.get('surname2').value;

        return temporalBankingData;
    }
    
    setDataFromCustomer(dataCustomer) {
        // Retramitaciones o seteamos datos del cliente
        // Datos de contacto
        if (dataCustomer) {
            if (dataCustomer.postal_address) {
                if (dataCustomer.postal_address.city && dataCustomer.postal_address.city !== '') {
                    this.formGroup.get('localidad').patchValue(dataCustomer.postal_address.city);
                }
                if (dataCustomer.postal_address.streetName && dataCustomer.postal_address.streetName !== '') {
                    this.formGroup.get('nombreVia').patchValue(dataCustomer.postal_address.streetName);
                }
                if (dataCustomer.postal_address.streetNr && dataCustomer.postal_address.streetNr !== '') {
                    this.formGroup.get('numero').patchValue(dataCustomer.postal_address.streetNr);
                }
                if (dataCustomer.postal_address.stateOrProvince && dataCustomer.postal_address.stateOrProvince !== '') {
                    this.formGroup.get('provincia').patchValue(dataCustomer.postal_address.stateOrProvince);
                }
                if (dataCustomer.postal_address.streetType && dataCustomer.postal_address.streetType !== '') {
                    this.formGroup.get('tipoVia').patchValue(dataCustomer.postal_address.streetType.toString());
                } else {
                    this.formGroup.get('tipoVia').patchValue('CALLE');
                }
                if (dataCustomer.postal_address.floorNumber && dataCustomer.postal_address.floorNumber !== '') {
                    this.formGroup.get('planta').patchValue(dataCustomer.postal_address.floorNumber);
                }
                if (dataCustomer.postal_address.apartmentNumber && dataCustomer.postal_address.apartmentNumber !== '') {
                    this.formGroup.get('puerta').patchValue(dataCustomer.postal_address.apartmentNumber);
                }
                if (dataCustomer.postal_address.staircaseNumber && dataCustomer.postal_address.staircaseNumber !== '') {
                    this.formGroup.get('escalera').patchValue(dataCustomer.postal_address.staircaseNumber);
                }
                if (dataCustomer.postal_address.postCode && dataCustomer.postal_address.postCode !== '') {
                    this.formGroup.get('codigoPostal').patchValue(dataCustomer.postal_address.postCode);
                    this.onChangeZip(dataCustomer.postal_address.postCode);
                }
            }

            // Datos personales
            if (dataCustomer.document_type && dataCustomer.document_type !== '') {
                this.formGroup.get('doctype').patchValue(dataCustomer.document_type);
            }
            this.formGroup.get('doctype').disable();

            if (dataCustomer.document && dataCustomer.document !== '') {
                this.formGroup.get('doc').patchValue(dataCustomer.document);
            }
            this.formGroup.get('doc').disable();

            if (dataCustomer.postal_address && dataCustomer.postal_address.country && dataCustomer.postal_address.country !== '') {
                const found = this.countries.find(x => x.description === dataCustomer.postal_address.country);
                this.formGroup.get('country').patchValue(found ? found.code : this.selectedCountry);                
            } else {
                this.formGroup.get('country').patchValue(this.selectedCountry);   
            }
            this.formGroup.get('country').disable();

            if (dataCustomer.first_name && dataCustomer.first_name !== '') {
                this.formGroup.get('firstName').patchValue(dataCustomer.first_name);
            }
            this.formGroup.get('firstName').disable();

            if (dataCustomer.last_name && dataCustomer.last_name !== '') {
                this.formGroup.get('surname1').patchValue(dataCustomer.last_name);
            }
            this.formGroup.get('surname1').disable();

            if (dataCustomer.second_last_name && dataCustomer.second_last_name !== '') {
                this.formGroup.get('surname2').patchValue(dataCustomer.second_last_name);
            }
            this.formGroup.get('surname2').disable();

            if (dataCustomer.birth_date && dataCustomer.birth_date !== '') {
                this.formGroup.get('birthday').patchValue(dataCustomer.birth_date);
            }
            this.formGroup.get('birthday').disable();

            if (dataCustomer.gender && dataCustomer.gender !== '') {
                this.formGroup.get('sex').patchValue(dataCustomer.gender);
            }
            this.formGroup.get('sex').disable();

            // if (dataCustomer.phone_number && dataCustomer.phone_number !== '') {
            //     this.formGroup.get('phone').patchValue(dataCustomer.phone_number);
                // this.formGroup.get('phone').disable();
            // }

            if (dataCustomer.email && dataCustomer.email !== '') {
                this.formGroup.get('email').patchValue(dataCustomer.email);
            }
        }
    }

    setDataFromNotCustomer(dataNotCustomer) {
        // Datos personales
        if (dataNotCustomer.customer_doctype && dataNotCustomer.customer_doctype !== '') {
            this.formGroup.get('doctype').patchValue(dataNotCustomer.customer_doctype);
            this.formGroup.get('doctype').disable();
            if (dataNotCustomer.customer_doctype === 'NIE' && this.formGroup.get('country').value === 'Spain') {
                this.selectedCountry = '';
            }
        }

        if (dataNotCustomer.customer_doc && dataNotCustomer.customer_doc !== '') {
            this.formGroup.get('doc').patchValue(dataNotCustomer.customer_doc);
            this.formGroup.get('doc').disable();
        }
    }

    onSelectTerminalDelivery(data: TerminalDeliveryModel) {
        this.formGroup.get('terminal_delivery').patchValue(data);
        if (this.terminalDelivery !== undefined) {
            this.terminalDelivery.errorForm = false;
        }
    }

    setMaxLengthByDoc(type) {
        this.formGroup.get('doc').patchValue('');
        this.maxLengthByDoc = getMaxLengthByDoc(brands.amena, type);
    }

    fillTypeRoad() {
        let name = this.formGroup.get('nombreVia').value;
        if (name && name !== '') {
            let nameStreet = getNameStreet(name, this.datosTipoVia, 'code');
            let typeStreet = this.getTypeStreet(name);
            this.formGroup.get('tipoVia').patchValue(typeStreet);
            this.formGroup.get('nombreVia').patchValue(nameStreet);
        }
    }

    getTypeStreet(value: string): string {
        if (this.datosTipoVia && this.datosTipoVia.length && value) {
            if (value.toLowerCase() === 'passatge') {
                value = 'pasaje';
            }
            const valueNormalized = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

            const tipoVia = this.datosTipoVia.filter(item => {
                const codeNormalized = item.code.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

                return valueNormalized.toLowerCase() === codeNormalized.toLowerCase();
            });

            if (tipoVia && tipoVia.length) {
                const code = tipoVia[0].code;

                return code;
            } else {
                return 'CALLE';
            }
        }

        return 'CALLE';
    }

    ngOnDestroy() {
        this.amenaApi.setDataFromNotCustomer(null);
        this.amenaApi.setDataFromCustomer(null);
        this.dataCustomer = null;
        this.formGroup.reset();
    }

    onChangeZip(value) {
        onChangeZip(value, this.datosProvincia, 'postal_code', this.formGroup.get('provincia'));
    }

    private _filter(value: string, values: any[]): any[] {
        const filterValue = value.toLowerCase();

        const auxValues = values.filter(option => option.description.toLowerCase().includes(filterValue));
        return auxValues && auxValues.length === 0 ? values : auxValues;
    }
}
